import { host } from "./../routes";
import axios from "axios";

const createClientUploaderPackage = async (formData, clientUploader) => {
    const url = `${host}/api/client_files/client_uploader/${clientUploader}/client_uploader_package/create`;
    const response = await axios.post(
        url,
        formData
    );
    return response.data;
};

export default createClientUploaderPackage;